import { call, take, put, select, fork } from 'redux-saga/effects';
import { callApi } from '../api';
import { SourceCategory } from '../Entities/Stories/stories.reducer';
import { searchProductsCallOptions } from '../../services/products.services';
import { getAttributeGroupName } from '../../utils/attributes';
import {
  fetchProductCount,
  updateProductCount,
  fetchCategoryMap,
  updateCategoryMap,
} from './copy-stream-categories.actions';
import {
  getStoryEditActiveAppId,
} from '../StoryEdit/story-edit.reducer';
import * as R from 'ramda';
import {
  CategoryMap,
  getVirtualSourceCategories,
} from './copy-stream-categories.reducer';

function* fetchCategoryMapping(categories: SourceCategory[]) {
  const currentAppId = yield select(getStoryEditActiveAppId);

  return {
    [currentAppId]: R.fromPairs(
      R.map(id => R.pair(id, id), R.pluck('categoryId')(categories))
    )
  };
}

export function* watchForFetchCategoryMap() {
  while (true) {
    const {
      payload: { categories },
    } = yield take(fetchCategoryMap.type);
    const categoryMap: CategoryMap = yield call(
      fetchCategoryMapping,
      categories
    );

    yield put(updateCategoryMap({ categoryMap: categoryMap }));

    const sourceCategories = yield select(
      getVirtualSourceCategories,
      categoryMap
    );

    yield put(fetchProductCount({ categories: sourceCategories }));
  }
}

function* setProductCount(sourceCategory: SourceCategory, appId: number) {
  const productCount = yield call(
    fetchProductCountForSourceCategory,
    sourceCategory,
    appId
  );
  yield put(
    updateProductCount({ categoryId: sourceCategory.categoryId, productCount })
  );
}

export function* watchForFetchProductCountForCategories() {
  while (true) {
    const {
      payload: { categories },
    } = yield take(fetchProductCount.type);
    const appId = yield select(getStoryEditActiveAppId);

    for (let i = 0; i < categories.length; i++) {
      const sourceCategory = categories[i];
      yield fork(setProductCount, sourceCategory, appId);
    }
  }
}

function* fetchProductCountForSourceCategory(
  sourceCategory: SourceCategory,
  appId: number
) {
  let filters = {};

  if (sourceCategory.attributeFilters) {
    for (let filter of sourceCategory.attributeFilters) {
      filters[getAttributeGroupName(filter.attributeGroupId)] =
        filter.attributeIds;
    }
  }

  const callOptions = yield searchProductsCallOptions(
    sourceCategory.categoryId,
    appId,
    0,
    0,
    filters
  );
  const { ok, data } = yield call(callApi, callOptions);

  if (!ok) {
    return 0;
  }

  return data && data.totalCount;
}



// WEBPACK FOOTER //
// ./src/store/CopyStreamCategories/copy-stream-categories.saga.ts